/**
 * <before-after> — moves the dividing line between two pictures with a range field laid over them.
 *
 * The position lives in one CSS variable (--ba-pos) that both the clipped picture and the line read, so the script
 * only copies the value of the field into it. The field does the rest: dragging, touch, arrow keys, Home and End.
 */
class BeforeAfter extends HTMLElement {
  connectedCallback() {
    this.range = this.querySelector('[data-range]');
    this.range?.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    this.range?.removeEventListener('input', this.onInput);
  }

  onInput = () => this.style.setProperty('--ba-pos', `${this.range.value}%`);
}

if (!customElements.get('before-after')) customElements.define('before-after', BeforeAfter);
